import { Pipe, PipeTransform } from '@angular/core';
import { Shop } from '@us/web/shared/data-access';
import { map, Observable, timer } from 'rxjs';

@Pipe({
    name: 'openTimeToDay',
    standalone: true,
    pure: true
})
export class OpenTimeToDayPipe implements PipeTransform {
    transform(shop: Shop): Observable<string | null> {
        return timer(0, 10 * 60 * 1000).pipe(
            map(() => {
                const day = new Date().getDay();
                const time = new Date().toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric' });
                const found = shop.open_hours.find(
                    e => e.day === day && e.periods[0].from < time && e.periods[0].to > time
                );

                if (!found) {
                    return null;
                }

                return found.periods.map(e => `${e.from} - ${e.to}`).join(', ');
            })
        );
    }
}
